export default "__VITE_ASSET__BslpRn8___"